import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environment';
import { normalizeApiArray } from '../utils/api-response.util';

@Injectable({
  providedIn: 'root'
})
export class OperationsService {
  private apiUrl = `${environment.apiUrl}/operations`;

  constructor(private http: HttpClient) {}

  getHealth(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/health`);
  }

  getNotifications(filters: { status?: string; contactMethod?: string; take?: number } = {}): Observable<any> {
    let params = new HttpParams().set('take', Math.min(500, Math.max(1, filters.take || 100)));
    if (filters.status?.trim()) params = params.set('status', filters.status.trim());
    if (filters.contactMethod?.trim()) params = params.set('contactMethod', filters.contactMethod.trim());
    return this.http.get<any>(`${this.apiUrl}/notifications`, { params });
  }

  getFleetHeartbeat(organisationId?: number): Observable<any[]> {
    const options = organisationId ? { params: { organisationId } } : {};
    return this.http.get<unknown>(`${this.apiUrl}/fleet-heartbeat`, options).pipe(
      map(response => normalizeApiArray<any>(response))
    );
  }
}
